import superagent from 'superagent'

const deerActivity = {
  // Days of deer movement at a stand: [{ date, context, curve }], one per local date from `date` (yyyy-MM-dd).
  fetchDays: (props) => {
    const { lat, lng, date, days, token } = props
    return new Promise((resolve, reject) => {
      superagent
        .get(`${__API_URI__}/DeerActivity/Get`)
        .query({ latitude: lat, longitude: lng, date, days })
        .set('Authorization', `Bearer ${token}`)
        .set('Platform', 'Web')
        .set('Version', `${__version__}`)
        .end((err, res) => {
          if (err) {
            return reject(err)
          }
          resolve(res.body)
        })
    })
  }
}

export default deerActivity
